import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { UploadResourceState } from '../types';
import { initialUploadResourceState } from './uploadResourceState';

export const uploadResourceSlice = createSlice({
  name: 'uploadResource',
  initialState: initialUploadResourceState,
  reducers: {
    setLimit: (state, action: PayloadAction<UploadResourceState['limit']>) => {
      state.limit = action.payload;
    },
    setPageIndex: (
      state,
      action: PayloadAction<UploadResourceState['pageIndex']>,
    ) => {
      state.pageIndex = action.payload;
    },
    setTotalRecordCount: (
      state,
      action: PayloadAction<UploadResourceState['totalRecordCount']>,
    ) => {
      state.totalRecordCount = action.payload;
    },
    setAddEditResourceModal: (
      state,
      action: PayloadAction<UploadResourceState['addEditResourceModal']>,
    ) => {
      state.addEditResourceModal = action.payload;
    },
  },
});

export const { actions: uploadResourceActions } = uploadResourceSlice;

const selectResource = (state: RootState) => state.uploadResource;

export const selectLimit = createSelector(
  selectResource,
  uploadResource => uploadResource.limit,
);
export const selectPageIndex = createSelector(
  selectResource,
  uploadResource => uploadResource.pageIndex,
);
export const selectTotalRecordCount = createSelector(
  selectResource,
  uploadResource => uploadResource.totalRecordCount,
);

export const selectAddEditResourceModal = createSelector(
  selectResource,
  uploadResource => uploadResource.addEditResourceModal,
);

export default uploadResourceSlice.reducer;
